import { createFileRoute } from '@tanstack/react-router';
import { ContestEditBasicStep } from '../pages/contests/edit/contest-edit-basic-step';

export const Route = createFileRoute('/contests/$id/edit/basic')({
  component: ContestEditBasicStep,
});
